import { render } from "./Contact.vue?vue&type=template&id=44e4a8b9&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=44e4a8b9&lang=css"
import "./Contact.vue?vue&type=style&index=1&id=44e4a8b9&scoped=true&lang=css"

import exportComponent from "/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44e4a8b9"]])

export default __exports__